// React
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as ServiceWorkerResigstration from './serviceWorkerRegistration';

// Future Lab
import { ReduxRoot } from './ReduxRoot';
// import * as serviceWorker from './serviceWorker';

const rootEl = document.getElementById('root');

if (!rootEl) {
	throw new Error('The application root element was not found.');
}

createRoot(rootEl).render(
	<StrictMode>
		<ReduxRoot />
	</StrictMode>
);

ServiceWorkerResigstration.register();
